import { Toaster as ToasterBase } from 'react-hot-toast';
import type { ToasterProps as ToasterPropsBase } from 'react-hot-toast';

export interface ToasterProps extends ToasterPropsBase {}

function Toaster(props: ToasterProps) {
  const { gutter = 8, position = 'top-right', ...rest } = props;

  return <ToasterBase gutter={gutter} position={position} {...rest} />;
}

export default Toaster;
